import lazyLoading from './lazyLoading'
import Global from '../../../services/globalservice'

export default {
  name: 'Change Password',
  meta: {
    icon: 'fa-key',
    expanded: false,
    roles: Global.ALL_ROLE
  },
  path: '/changePassword',
  component: lazyLoading('user/ChangePassword')
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/changePassword.js